import { RequestEvent } from 'state-data';

export class UserProfileBasicInfoSavedEvent extends RequestEvent {}
